/* ZilZal — site-wide custom scripts, gathered from the inline <script> blocks of the custom snippets and
   sections (speed pass, Oct 2026). Loaded once with defer from layout/theme.liquid and cached, instead of
   ~95 KB of script parsed on every page view. The floating cart runs first (it wraps window.fetch so the
   other parts share its cart reads); the rest run in the order they used to appear in the page.
   Each part is its own function scope, exactly as before. */

/* ---- from snippets/zz-floating-cart.liquid ---- */
(function () {
  var root = document.getElementById('zzfc-root');
  var pill = document.getElementById('zzfc');
  var overlay = document.getElementById('zzcart-overlay');
  var sheet = document.getElementById('zzcart');
  if (!root || !pill || !sheet) return;

  var countEl = root.querySelector('[data-zzfc-count]');
  var totalEl = root.querySelector('[data-zzfc-total]');
  var itemsEl = sheet.querySelector('[data-zzcart-items]');
  var footEl = sheet.querySelector('.zzcart__foot');
  var sCount = sheet.querySelector('[data-zzcart-count]');
  var sTotal = sheet.querySelector('[data-zzcart-total]');
  var checkoutEl = sheet.querySelector('[data-zzcart-checkout]');
  var discLine = sheet.querySelector('[data-zzcart-discline]');
  var discCode = sheet.querySelector('[data-zzcart-disccode]');
  var discAmt = sheet.querySelector('[data-zzcart-discamt]');
  var codeInput = sheet.querySelector('[data-zzcart-code]');
  var applyBtn = sheet.querySelector('[data-zzcart-apply]');
  var promoMsg = sheet.querySelector('[data-zzcart-promomsg]');
  var fxEl = sheet.querySelector('[data-zzcart-fx]');
  var fxSar = sheet.querySelector('[data-zzcart-sar]');

  var cartUrl = root.getAttribute('data-cart-url') || '/cart';
  var rootPath = cartUrl.replace(/cart$/, '');

  var cache = null;      // last known cart JSON
  var inflight = null;   // shared promise, so parallel callers do not duplicate
  var renderedFor = -1;  // items html is only rebuilt when the cart really changed

  if (checkoutEl) checkoutEl.setAttribute('href', cartUrl.replace(/cart$/, 'checkout'));
  if (fxEl) fxEl.addEventListener('click', function () { fxEl.classList.toggle('is-open'); });

  /* Empty the whole cart. First tap arms the button, a second tap within 4s clears.
     /cart/clear.js returns the (empty) cart, so commit() repaints everything listening
     to zz:cart (pill, offers, cashback line, product-page stepper) without another GET. */
  var clearBtn = sheet.querySelector('[data-zzcart-clear]');
  var clearLbl = clearBtn ? clearBtn.querySelector('[data-zzcart-clear-l]') : null;
  var armT = null;
  function disarmClear() {
    if (!clearBtn) return;
    clearTimeout(armT); armT = null;
    clearBtn.classList.remove('is-armed');
    if (clearLbl) clearLbl.textContent = clearBtn.getAttribute('data-l-idle');
  }
  if (clearBtn) clearBtn.addEventListener('click', function () {
    if (clearBtn.disabled) return;
    if (!clearBtn.classList.contains('is-armed')) {
      clearBtn.classList.add('is-armed');
      if (clearLbl) clearLbl.textContent = clearBtn.getAttribute('data-l-confirm');
      armT = setTimeout(disarmClear, 4000);
      return;
    }
    clearTimeout(armT);
    clearBtn.disabled = true;
    fetch(cartUrl + '/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: '{}' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { commit(cart); })
      .catch(function () { refresh(); })
      .then(function () { clearBtn.disabled = false; disarmClear(); });
  });

  function pruneFoot() {
    if (!footEl) return;
    var kids = footEl.children;
    for (var i = kids.length - 1; i >= 0; i--) {
      if (!kids[i].hasAttribute('data-zzkeep')) kids[i].remove();
    }
  }
  if (footEl && window.MutationObserver) new MutationObserver(pruneFoot).observe(footEl, { childList: true });

  /* Every amount in this drawer. Carries its exact SAR value in cents; the
     visible text is a plain SAR fallback. assets/zz-currency.js converts it
     into the visitor's currency and draws the symbol. Deliberately NOT .money
     — see the header comment. */
  function money(cents) {
    var c = Math.round(Number(cents) || 0);
    var p = (c / 100).toFixed(2).split('.');
    return '<span class="zz-amt" data-zz-sar-cents="' + c + '">' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1] + ' SR</span>';
  }

  function esc(s) { return ('' + s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Checkout is charged in the shop currency (SAR). Show the exact SAR figure,
     and only to visitors who are looking at another currency. */
  function sarText(cents) {
    var p = ((cents || 0) / 100).toFixed(2).split('.');
    return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1] + ' ر.س';
  }
  /* Oct 2026 #3: the visitor's currency now comes from assets/zz-currency.js (BUCKS removed). */
  function displayCurrency() {
    return document.documentElement.getAttribute('data-zz-cur') || 'SAR';
  }
  function paintFx(cart) {
    if (!fxEl) return;
    if (fxSar) fxSar.textContent = sarText(cart.total_price);
    fxEl.hidden = displayCurrency() === 'SAR';
  }

  /* ===== Oct 2026: BloxCart-style pill (see header comment) ===== */
  var tintEl = pill.querySelector('.zzfc__tint');
  var iconEl = pill.querySelector('.zzfc__icon');
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var ODH = 1.15, DIG = '<i>0</i><i>1</i><i>2</i><i>3</i><i>4</i><i>5</i><i>6</i><i>7</i><i>8</i><i>9</i>';
  function isD(ch) { return ch >= '0' && ch <= '9'; }
  /* Draw str as rolling digit columns. Digits are matched to the old value from the right, so
     12.50 -> 13.50 only rolls the one column that changed. */
  function odo(el, str, anim) {
    if (!el) return;
    str = String(str);
    var old = el.__odo;
    if (old === str) return;
    el.__odo = str;
    if (old == null || RM.matches) anim = false;
    var html = '', L = str.length, OL = old ? old.length : 0, plan = [];
    for (var i = 0; i < L; i++) {
      var ch = str.charAt(i);
      if (!isD(ch)) { html += '<span class="zzod__s">' + esc(ch) + '</span>'; continue; }
      var r = L - 1 - i, oc = (anim && OL - 1 - r >= 0) ? old.charAt(OL - 1 - r) : '';
      var from = anim ? (isD(oc) ? +oc : 0) : +ch;
      plan.push([from, +ch, r]);
      html += '<span class="zzod__d"><span class="zzod__r" style="transform:translateY(' + (-from * ODH).toFixed(2) + 'em)">' + DIG + '</span></span>';
    }
    el.innerHTML = '<span class="zzod" aria-hidden="true">' + html + '</span><span class="zzod__sr">' + esc(str) + '</span>';
    if (!anim) return;
    var cols = el.querySelectorAll('.zzod__r');
    void el.offsetWidth;
    for (var j = 0; j < cols.length; j++) {
      var pl = plan[j];
      if (!pl || pl[0] === pl[1]) continue;
      cols[j].style.transitionDelay = (pl[2] * 35) + 'ms';
      cols[j].style.transform = 'translateY(' + (-pl[1] * ODH).toFixed(2) + 'em)';
    }
  }
  function sarFmt(c) { var p = ((Number(c) || 0) / 100).toFixed(2).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1]; }
  function parts(c) {
    try { if (window.zzFx && window.zzFx.parts) return window.zzFx.parts(c); } catch (e) {}
    return { code: 'SAR', num: sarFmt(c), pre: '', post: ' SR', sym: '' };
  }
  function totalIn(el, c, anim) {
    if (!el) return;
    var p = parts(c), sig = p.code + '|' + p.pre + '|' + p.post + '|' + p.sym;
    if (el.__sig !== sig || !el.querySelector('.zzfc__num')) {
      el.__sig = sig;
      el.innerHTML = '<span class="zzfc__amt" dir="ltr">'
        + (p.sym ? '<span class="zzfc__sym">' + p.sym + '</span>' : (p.pre ? '<span>' + esc(p.pre) + '</span>' : ''))
        + '<span class="zzfc__num"></span>' + (p.post ? '<span>' + esc(p.post) + '</span>' : '') + '</span>';
      anim = false;
    }
    odo(el.querySelector('.zzfc__num'), p.num, anim);
  }
  function renderTotal(c, anim) {
    totalIn(totalEl, c, anim);
    var h = headerCart(); if (h) totalIn(h.total, c, anim);
  }

  /* PC header cart: the theme's button + our badge, label and total (from #zzhc-tpl). */
  var hcTpl = document.getElementById('zzhc-tpl'), hc = null;
  function headerCart() {
    var btn = document.querySelector('header-actions cart-drawer-component > button');
    if (!btn || !hcTpl || !hcTpl.content) return null;
    if (hc && hc.btn === btn && btn.contains(hc.total)) return hc;
    if (!btn.querySelector('.zzhc__txt')) btn.appendChild(hcTpl.content.cloneNode(true));
    btn.classList.add('zzhc-on');
    hc = { btn: btn, count: btn.querySelector('[data-zzhc-count]'), total: btn.querySelector('[data-zzhc-total]'), tint: btn.querySelector('.zzhc__tint') };
    if (typeof dispN === 'number') {
      odo(hc.count, dispN, false);
      totalIn(hc.total, dispC, false);
      btn.classList.toggle('is-empty', !(dispN > 0));
    }
    return hc;
  }

  /* What the pill shows. Starts from the server-rendered HTML. */
  var dispN = parseInt(countEl && countEl.textContent, 10) || 0;
  var dispC = (function () { var t = totalEl && totalEl.querySelector('[data-zz-sar-cents]'); return t ? (parseInt(t.getAttribute('data-zz-sar-cents'), 10) || 0) : 0; })();
  if (countEl) countEl.__odo = String(dispN);
  function renderPill(n, c, anim) {
    dispN = n; dispC = c;
    odo(countEl, n, anim);
    var h = headerCart();
    if (h) { odo(h.count, n, anim); h.btn.classList.toggle('is-empty', !(n > 0)); }
    renderTotal(c, anim);
    root.setAttribute('data-empty', n > 0 ? 'false' : 'true');
    if (n > 0) schedule();   /* pill (re)appears: place it above any bottom bar on this frame */
    /* keep the header cart button's count in step (PC) — through the theme's own cart-icon component */
    try {
      Array.prototype.forEach.call(document.querySelectorAll('header-actions cart-icon'), function (ci) {
        if (typeof ci.renderCartBubble === 'function') ci.renderCartBubble(n, false, false);
      });
    } catch (e) {}
  }

  /* Optimistic changes, and the cart writes in flight that will confirm them. */
  var deltas = [], pendingW = 0, writeSeq = 0;
  function holding() {
    if (pendingW > 0) return true;
    for (var i = 0; i < deltas.length; i++) if (!deltas[i].claimed) return true;
    return false;
  }
  function showServer(cart, anim) { deltas = []; renderPill(cart.item_count || 0, cart.total_price || 0, anim !== false); }
  function settle() { if (!holding() && cache) showServer(cache, true); }
  function claimAll() { for (var i = 0; i < deltas.length; i++) deltas[i].claimed = true; }

  /* media query, not window.innerWidth: on phones reading innerWidth forces a full page layout */
  var MQD = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  function desk() { return MQD ? MQD.matches : window.innerWidth >= 750; }
  function cartTarget() {
    if (desk()) {
      var h = headerCart();
      if (h && h.btn.getBoundingClientRect().width) {
        var ic = h.btn.querySelector('.header-actions__cart-icon');
        return (ic && ic.getBoundingClientRect().width) ? ic : h.btn;
      }
    }
    return iconEl || pill;
  }
  function popBadge() {
    var b = desk() ? (hc && hc.count) : countEl;
    if (RM.matches || !b || !b.animate) return;
    b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)', offset: 0.35 }, { transform: 'scale(1)' }], { duration: 460, easing: 'cubic-bezier(.34,1.56,.64,1)' });
  }
  function land() {
    if (RM.matches || !pill.animate) return;
    try {
      var tg = cartTarget(), bump = [{ transform: 'scale(1)' }, { transform: 'scale(1.07)', offset: 0.3 }, { transform: 'scale(1)' }];
      if (tg === iconEl || tg === pill) {
        pill.animate(bump, { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
        if (iconEl) iconEl.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(3px)', offset: 0.25 }, { transform: 'translateY(0)' }], { duration: 420, easing: 'cubic-bezier(.22,1,.36,1)' });
        if (tintEl) tintEl.animate([{ opacity: 0.6 }, { opacity: 0 }], { duration: 650, easing: 'cubic-bezier(.25,.46,.45,.94)' });
      } else {
        var hb = (hc && hc.btn) || tg;
        hb.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.06)', offset: 0.3 }, { transform: 'scale(1)' }], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' });
        if (hc && hc.tint) hc.tint.animate([{ opacity: 0.45 }, { opacity: 0 }], { duration: 650, easing: 'cubic-bezier(.25,.46,.45,.94)' });
      }
    } catch (e) {}
  }
  /* The product picture drops into the cart: X and Y are animated on two nested boxes with
     different easings, which draws an arc (Y first lifts a little, then falls). */
  function fly(img, done) {
    var called = false;
    function fin() { if (!called) { called = true; done(); } }
    try {
      if (RM.matches || !img || !img.getBoundingClientRect || !pill.animate) return fin();
      var a = img.getBoundingClientRect(), vh = window.innerHeight || 800;
      if (!a.width || a.bottom < 0 || a.top > vh) return fin();
      var tg = cartTarget(), b = tg.getBoundingClientRect();
      if (!b.width) return fin();
      var S = Math.round(Math.max(44, Math.min(72, a.width * 0.6)));
      var sx = a.left + a.width / 2 - S / 2, sy = a.top + a.height / 2 - S / 2;
      var dx = b.left + b.width / 2 - S / 2 - sx, dy = b.top + b.height / 2 - S / 2 - sy;
      var box = document.createElement('div');
      box.className = 'zzfly';
      box.style.cssText = 'left:' + sx.toFixed(1) + 'px;top:' + sy.toFixed(1) + 'px;width:' + S + 'px;height:' + S + 'px';
      var im = document.createElement('img');
      im.alt = ''; im.decoding = 'async'; im.src = img.currentSrc || img.src;
      box.appendChild(im);
      document.body.appendChild(box);
      var D = 560;
      box.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx.toFixed(1) + 'px)' }], { duration: D, easing: 'cubic-bezier(.25,.1,.35,1)', fill: 'forwards' });
      var an = im.animate([{ transform: 'translateY(0) scale(1)', opacity: 1 }, { transform: 'translateY(' + dy.toFixed(1) + 'px) scale(.3)', opacity: 0.9 }],
        { duration: D, easing: dy > 0 ? 'cubic-bezier(.5,-0.6,.8,.5)' : 'cubic-bezier(.2,.6,.3,1)', fill: 'forwards' });
      var end = function () { if (box.parentNode) box.parentNode.removeChild(box); fin(); };
      an.onfinish = end; an.oncancel = end; setTimeout(end, D + 400);
    } catch (e) { fin(); }
  }
  /* o = { n: items added (negative removes), c: SAR cents, img: picture to drop } */
  function addFx(o) {
    o = o || {};
    var n = parseInt(o.n, 10) || 0, c = Math.round(Number(o.c) || 0);
    if (!n && !c) return;
    var d = { claimed: false };
    deltas.push(d);
    setTimeout(function () { if (!d.claimed) { var i = deltas.indexOf(d); if (i > -1) deltas.splice(i, 1); settle(); } }, 1800);
    renderPill(Math.max(0, dispN + n), Math.max(0, dispC + c), true);
    if (n > 0) { popBadge(); if (o.img) fly(o.img, land); else land(); }
  }
  window.zzCartFx = {
    add: addFx,
    /* drawer +/- (snippets/zz-cart-speed.liquid): count only, no animation */
    count: function (n) { n = Math.max(0, parseInt(n, 10) || 0); dispN = n; odo(countEl, n, false); root.setAttribute('data-empty', n > 0 ? 'false' : 'true'); if (n > 0) schedule(); }
  };
  /* currency script ready / visitor switched currency: redraw the total in it */
  document.addEventListener('zz:fx', function () { renderTotal(dispC, false); });
  headerCart();
  /* Some pages (e.g. the translated ones) rebuild the header button's contents after load:
     put the badge, label and total back whenever they go missing. rAF-throttled, one lookup. */
  (function () {
    var hg = document.getElementById('header-group') || document.querySelector('header-actions');
    if (!hg || !window.MutationObserver) return;
    var q = false;
    new MutationObserver(function () {
      if (q) return; q = true;
      requestAnimationFrame(function () {
        q = false;
        var b = document.querySelector('header-actions cart-drawer-component > button');
        if (b && !b.querySelector('.zzhc__txt')) headerCart();
      });
    }).observe(hg, { childList: true, subtree: true });
  })();
  if (window.zzFx) renderTotal(dispC, false);

  function paintSheet(cart) {
    /* paid items first, free gifts grouped underneath them (stable order otherwise) */
    var items = (cart.items || []).filter(function (it) { return it.product_type !== 'Gift'; })
      .concat((cart.items || []).filter(function (it) { return it.product_type === 'Gift'; }));
    if (sCount) sCount.textContent = cart.item_count || 0;
    totalIn(sTotal, cart.total_price, sheet.classList.contains('is-open'));
    sheet.setAttribute('data-empty', items.length ? 'false' : 'true');
    paintFx(cart);

    /* Skip the innerHTML rebuild when nothing changed — reparsing the list is
       the most expensive part of opening the drawer. */
    var stamp = (cart.item_count || 0) + ':' + (cart.total_price || 0) + ':' + items.length + ':' + (cart.total_discount || 0);
    if (stamp !== renderedFor) {
      var html = '';
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="zzcart__variant">' + esc(it.variant_title) + '</div>' : '';
        /* 120px thumbnail instead of the full-size product picture (decoding big pictures made opening the drawer stutter) */
        var thumbUrl = it.image ? (/[?&]width=/.test(it.image) ? it.image : it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=120') : '';
        var img = it.image ? '<img class="zzcart__img" src="' + esc(thumbUrl) + '" alt="" decoding="async" width="54" height="54">' : '<span class="zzcart__img"></span>';
        var gift = it.product_type === 'Gift';
        var ZT = (window.ZZ_UPSELL && window.ZZ_UPSELL.t) || {};
        var priceHtml = (gift && it.final_line_price === 0)
          ? '<span class="zzcart__free">' + esc(ZT.free || 'FREE') + '</span> <s class="zzcart__was">' + money(it.original_line_price) + '</s>'
          : money(it.final_line_price);
        html += '<div class="zzcart__item' + (gift ? ' is-gift' : '') + '" data-key="' + esc(it.key) + '">' + img
          + '<div class="zzcart__info"><a class="zzcart__name" href="' + esc(it.url || '#') + '">' + esc(it.product_title || it.title) + '</a>' + variant
          + '<div class="zzcart__price">' + priceHtml + '</div></div>'
          + (gift ? '' : '<div class="zzcart__qty"><button class="zzcart__qbtn" data-zzplus type="button" aria-label="+">+</button><span class="zzcart__qn">' + it.quantity + '</span><button class="zzcart__qbtn" data-zzminus type="button" aria-label="-">−</button></div>')
          + '<button class="zzcart__remove" data-zzremove type="button" aria-label="حذف"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>'
          + '</div>';
      }
      itemsEl.innerHTML = html;
      renderedFor = stamp;
    }

    var dcs = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
    if (cart.total_discount && cart.total_discount > 0) {
      discLine.style.display = 'flex';
      discCode.textContent = dcs.length ? ('خصم (' + String(dcs[0].code).toUpperCase() + ')') : 'الخصم';
      discAmt.innerHTML = '<bdi dir="ltr">−' + money(cart.total_discount) + '</bdi>';
    } else { discLine.style.display = 'none'; }
    pruneFoot();
  }

  /* Single entry point. Anything holding a fresh cart object calls this and no
     network request happens at all. */
  function commit(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;
    var prevCart = cache;
    cache = cart;
    if (!holding()) showServer(cart, true);   /* writes still in flight: keep the optimistic numbers */
    if (sheet.classList.contains('is-open')) paintSheet(cart);
    else prePaint();
    if (prevCart) {
      var was = codesOf(prevCart), fresh = codesOf(cart).filter(function (c) { return was.indexOf(c) < 0; });
      var saved = (cart.total_discount || 0) - (prevCart.total_discount || 0);
      if (fresh.length && saved > 0) celebrate(saved);
    }
    document.dispatchEvent(new CustomEvent('zz:cart', { detail: cart }));   /* offers engine (snippets/zz-upsell.liquid) listens */
  }

  /* Oct 2026: build the drawer's contents while the phone is idle, so tapping the cart only
     slides it in (building the list on the tap itself cost a dropped frame or two on phones). */
  var preT = null;
  function prePaint() {
    if (preT) return;
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
    preT = idle(function () {
      preT = null;
      if (cache && !sheet.classList.contains('is-open')) paintSheet(cache);
    }, { timeout: 2000 });
  }

  /* A GET that started before a cart write describes the cart before that write: its answer is
     returned to the caller but never committed (it used to roll the pill backwards). */
  function refresh() {
    if (inflight && inflight.__seq === writeSeq) return inflight;
    var seq = writeSeq;
    var pr = fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (inflight === pr) inflight = null; if (seq === writeSeq) commit(cart); return cart; })
      .catch(function () { if (inflight === pr) inflight = null; });
    pr.__seq = seq;
    inflight = pr;
    return pr;
  }

  /* Exposed so other add-to-cart implementations on the page (product cards,
     collection shelves, etc.) can kick off a cart refresh the instant a click
     happens, in parallel with their own /cart/add.js or /cart/change.js call,
     instead of waiting for the fetch-patch below to react only after that
     call finishes. Also listen for the bxc:cart-updated event some of those
     scripts already dispatch, so the pill stays in sync either way. */
  window.zzCartRefresh = refresh;
  document.addEventListener('bxc:cart-updated', refresh);

  function change(key, qty) {
    fetch(cartUrl + '/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) { commit(cart); })
      .catch(function () {});
  }

  /* ===== discount code celebration (see header comment) ===== */
  var discLineEl = sheet.querySelector('[data-zzcart-discline]');
  var lastApply = 0;
  function codesOf(c) { return ((c && c.discount_codes) || []).filter(function (d) { return d.applicable; }).map(function (d) { return String(d.code).toUpperCase(); }); }
  function confetti(x, y) {
    if (RM.matches || !document.body.animate) return;
    var box = document.createElement('div');
    box.className = 'zzconf';
    var C = ['#C9A646', '#E0BE63', '#34D399', '#F8FAFC', '#60A5FA', '#F472B6'], N = 30, maxT = 0;
    for (var i = 0; i < N; i++) {
      var p = document.createElement('i'), w = 5 + Math.random() * 4, h = Math.random() < 0.5 ? w : w * 1.8;
      p.style.cssText = 'left:' + x.toFixed(1) + 'px;top:' + y.toFixed(1) + 'px;width:' + w.toFixed(1) + 'px;height:' + h.toFixed(1) + 'px;background:' + C[i % C.length] + (Math.random() < 0.3 ? ';border-radius:50%' : '');
      box.appendChild(p);
    }
    document.body.appendChild(box);
    var ps = box.children;
    for (var j = 0; j < ps.length; j++) {
      var ang = (-90 + (Math.random() * 130 - 65)) * Math.PI / 180, v = 110 + Math.random() * 170;
      var dx = Math.cos(ang) * v, up = Math.sin(ang) * v, fall = 150 + Math.random() * 150, rot = Math.random() * 760 - 380;
      var T = 900 + Math.random() * 500; if (T > maxT) maxT = T;
      ps[j].animate([
        { transform: 'translate(-50%,-50%) translate(0,0) rotate(0deg)', opacity: 1, easing: 'cubic-bezier(.15,.7,.35,1)' },
        { transform: 'translate(-50%,-50%) translate(' + (dx * 0.75).toFixed(1) + 'px,' + up.toFixed(1) + 'px) rotate(' + (rot * 0.4).toFixed(0) + 'deg)', opacity: 1, offset: 0.38, easing: 'cubic-bezier(.45,0,.85,.5)' },
        { transform: 'translate(-50%,-50%) translate(' + dx.toFixed(1) + 'px,' + (up + fall).toFixed(1) + 'px) rotate(' + rot.toFixed(0) + 'deg)', opacity: 0 }
      ], { duration: T, fill: 'forwards' });
    }
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, maxT + 80);
  }
  function savedChip(cents) {
    if (RM.matches || !sTotal || !document.body.animate) return;
    /* sits in the empty middle of the discount line (code on one side, amount on the other) */
    var r = (discLineEl && discLineEl.offsetParent ? discLineEl : sTotal).getBoundingClientRect();
    if (!r.width) return;
    var p = parts(cents), chip = document.createElement('div');
    chip.className = 'zzsave';
    chip.innerHTML = '<span>' + esc(sheet.getAttribute('data-l-saved') || '') + '</span><span class="zzfc__amt" dir="ltr">'
      + (p.sym ? '<span class="zzfc__sym">' + p.sym + '</span>' : esc(p.pre)) + esc(p.num) + esc(p.post) + '</span>';
    chip.style.left = (r.left + r.width / 2).toFixed(1) + 'px';
    chip.style.top = (r.top + r.height / 2).toFixed(1) + 'px';
    document.body.appendChild(chip);
    var a = chip.animate([
      { transform: 'translate(-50%,-50%) translateY(6px) scale(.7)', opacity: 0 },
      { transform: 'translate(-50%,-50%) translateY(-2px) scale(1.06)', opacity: 1, offset: 0.2 },
      { transform: 'translate(-50%,-50%) translateY(-8px) scale(1)', opacity: 1, offset: 0.75 },
      { transform: 'translate(-50%,-50%) translateY(-30px) scale(1)', opacity: 0 }
    ], { duration: 1900, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
    var gone = function () { if (chip.parentNode) chip.parentNode.removeChild(chip); };
    a.onfinish = gone; setTimeout(gone, 2300);
  }
  function celebrate(saved) {
    if (!sheet.classList.contains('is-open')) return;   /* the pill/header totals still roll down */
    var fromBtn = Date.now() - lastApply < 6000 && applyBtn && applyBtn.getBoundingClientRect().width;
    if (fromBtn) {
      applyBtn.classList.add('is-ok'); codeInput.classList.add('is-ok');
      setTimeout(function () { applyBtn.classList.remove('is-ok'); codeInput.classList.remove('is-ok'); }, 1600);
    }
    if (RM.matches) return;
    try {
      var o = (fromBtn ? applyBtn : (discLineEl && discLineEl.offsetParent ? discLineEl : sTotal)).getBoundingClientRect();
      confetti(o.left + o.width / 2, o.top + o.height / 2);
      if (fromBtn) applyBtn.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.1)', offset: 0.3 }, { transform: 'scale(1)' }], { duration: 480, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      if (discLineEl && discLineEl.offsetParent) {
        discLineEl.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
        discLineEl.animate([{ backgroundColor: 'rgba(52,211,153,.24)' }, { backgroundColor: 'rgba(52,211,153,0)' }], { duration: 1300, easing: 'ease-out' });
      }
      savedChip(saved);
    } catch (e) {}
  }
  function codeFailed() {
    codeInput.classList.add('is-err');
    setTimeout(function () { codeInput.classList.remove('is-err'); }, 1400);
    if (RM.matches || !codeInput.animate) return;
    codeInput.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(3px)' }, { transform: 'translateX(0)' }], { duration: 380, easing: 'ease-out' });
  }

  function applyCode() {
    var code = (codeInput.value || '').trim();
    if (!code || applyBtn.classList.contains('is-loading')) return;
    applyBtn.classList.add('is-loading');
    lastApply = Date.now();
    promoMsg.className = 'zzcart__promo-msg';
    promoMsg.textContent = '';
    fetch(rootPath + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl + '.js'), { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        commit(cart);
        applyBtn.classList.remove('is-loading');
        var ok = (cart.discount_codes || []).filter(function (d) { return d.applicable && d.code.toLowerCase() === code.toLowerCase(); });
        /* success only when THIS code applies (an automatic discount used to make any code look accepted) */
        if (ok.length) { promoMsg.className = 'zzcart__promo-msg is-ok'; promoMsg.textContent = 'تم تطبيق الكود'; }
        else { promoMsg.className = 'zzcart__promo-msg is-err'; promoMsg.textContent = 'الكود غير صالح أو منتهي'; codeFailed(); }
      })
      .catch(function () {
        applyBtn.classList.remove('is-loading');
        codeFailed();
        promoMsg.className = 'zzcart__promo-msg is-err';
        promoMsg.textContent = 'تعذّر تطبيق الكود';
      });
  }

  /* Opens immediately from cache. The network call, if any, only revalidates. */
  function openSheet() {
    if (cache) paintSheet(cache);
    overlay.classList.add('is-open');
    sheet.classList.add('is-open');
    root.classList.add('zzcart-open');
    document.documentElement.style.overflow = 'hidden';
    if (!cache) refresh();
  }
  function closeSheet() {
    disarmClear();
    overlay.classList.remove('is-open');
    sheet.classList.remove('is-open');
    root.classList.remove('zzcart-open');
    document.documentElement.style.overflow = '';
  }

  pill.addEventListener('click', openSheet);
  /* PC: the header cart button opens this drawer (capture phase, before the theme's own drawer).
     Delegated on the document, so it keeps working after the theme re-renders the header. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('header-actions cart-drawer-component > button') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    /* Oct 2026 #4: open only, never toggle. The theme's own cart handler can run first on a real click:
       it opens its native dialog, the observer below swaps that for this drawer, and a toggle here then
       closed it again in the same click, so on PC the cart never opened. The button is under the
       overlay once the drawer is open, so it never needs to close it. */
    openSheet();
  }, true);
  overlay.addEventListener('click', closeSheet);
  Array.prototype.forEach.call(sheet.querySelectorAll('[data-zzcart-close]'), function (b) { b.addEventListener('click', closeSheet); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  applyBtn.addEventListener('click', applyCode);
  codeInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyCode(); } });

  itemsEl.addEventListener('click', function (e) {
    var row = e.target.closest('.zzcart__item'); if (!row) return;
    var key = row.getAttribute('data-key');
    var qn = row.querySelector('.zzcart__qn'); var q = parseInt(qn && qn.textContent, 10) || 1;
    if (e.target.closest('[data-zzplus]')) change(key, q + 1);
    else if (e.target.closest('[data-zzminus]')) change(key, Math.max(0, q - 1));
    else if (e.target.closest('[data-zzremove]')) change(key, 0);
  });

  /* The visitor can change currency while the drawer is open: re-evaluate
     whether the SAR note applies. (Amounts re-convert on their own.)
     Oct 2026 #3: listens for zz-currency.js's 'zz:fx' event instead of checking every 600 ms. */
  document.addEventListener('zz:fx', function () {
    if (cache && sheet.classList.contains('is-open')) paintFx(cache);
  });

  var nativeDlg = document.querySelector('.cart-drawer__dialog');
  if (nativeDlg) { new MutationObserver(function () { if (nativeDlg.open) { try { nativeDlg.close(); } catch (e) {} openSheet(); } }).observe(nativeDlg, { attributes: true, attributeFilter: ['open'] }); }

  /* /cart/add.js and /cart/change.js return the updated cart in their own
     response body. Read it directly instead of chasing with another GET. */
  var rxMutate = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  /* Speed (Oct 2026): every page load fired 4–5 identical GET /cart.js requests at once (this drawer, the
     min-qty script, the offers engine, the rewards line, ...). Identical reads that start while one is in
     flight, or within half a second after it with no cart write in between, now share that one response
     (each caller gets its own copy). Any write starts a fresh read. */
  var rxCartGet = /\/cart\.js(\?|$)/;
  var getShared = null;   /* { url, seq, p, until } */
  function plainGet(a) {
    if (!(typeof a[0] === 'string' || (window.URL && a[0] instanceof URL))) return false;
    var m = a[1] && a[1].method;
    return !m || String(m).toUpperCase() === 'GET';
  }
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var url = '';
      try { url = (arguments[0] && arguments[0].url) ? arguments[0].url : ('' + arguments[0]); } catch (e) {}
      if (rxCartGet.test(url) && plainGet(arguments)) {
        var g = getShared, now = Date.now();
        if (g && g.url === url && g.seq === writeSeq && (g.until === 0 || now < g.until)) {
          return g.p.then(function (r) { return r.clone(); });
        }
        var base = nativeFetch.apply(this, arguments);
        var entry = { url: url, seq: writeSeq, p: base, until: 0 };
        getShared = entry;
        base.then(function (r) { if (r && r.ok) entry.until = Date.now() + 500; else if (getShared === entry) getShared = null; },
                  function () { if (getShared === entry) getShared = null; });
        return base.then(function (r) { return r.clone(); });
      }
      var isW = rxMutate.test(url);
      if (isW) { pendingW++; writeSeq++; claimAll(); }
      var p = nativeFetch.apply(this, arguments);
      if (isW) {
        var left = false;
        var dec = function () { if (!left) { left = true; pendingW = Math.max(0, pendingW - 1); } };
        p.then(function (res) {
          if (!res || !res.ok) { dec(); refresh(); return; }
          res.clone().json().then(function (data) {
            dec();
            if (data && typeof data.item_count !== 'undefined') commit(data);
            else refresh();
          }).catch(function () { dec(); refresh(); });
        }).catch(function () { dec(); settle(); });
      }
      return p;
    };
  }

  var BASE = 18, GAP = 12;
  function lift() {
    /* Speed (Oct 2026): nothing to place while the pill is hidden (empty cart — most visits). This ran
       a hit-test of the page on every scrolled frame; renderPill() calls it again when the pill appears. */
    if (root.getAttribute('data-empty') === 'true') return;
    var vh = window.innerHeight, vw = window.innerWidth, obstacleTop = vh;
    try {
      var stack = document.elementsFromPoint(vw / 2, vh - 3) || [];
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (!el || el === document.documentElement || el === document.body) continue;
        if (el.closest && el.closest('#zzfc-root')) continue;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
        var r = el.getBoundingClientRect();
        if (r.height > vh * 0.5 || r.width < vw * 0.5) continue;
        if (r.bottom >= vh - 4 && r.top > vh * 0.35) { obstacleTop = Math.min(obstacleTop, r.top); break; }
      }
    } catch (e) {}
    var bottom = (obstacleTop < vh) ? (vh - obstacleTop + GAP) : BASE;
    root.style.setProperty('--zzfc-bottom', 'calc(' + bottom + 'px + env(safe-area-inset-bottom,0px))');
  }
  var raf; function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; lift(); }); }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  schedule();   /* first placement on the next frame, not mid-page (that forced a layout of the half-loaded page) */

  pruneFoot();
  refresh();
})();

;
/* ---- from sections/zz-fixes.liquid (hero add-to-cart stepper) ---- */
(function(){
var TRASH_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';
var addLabel={};
var lineKey={};    // vid -> this line's current real key ("variantId:propsHash"), refreshed after every request
var pendingAdd={};  // vid -> in-flight /cart/add.js promise, while the line doesn't exist yet
var timers={};      // vid -> pending debounce timer for a queued quantity change
function addBtnHTML(vid,label){return '<button type="button" class="zh-card__btn" data-zh-add data-variant-id="'+vid+'">'+label+'</button>';}
function qtyHTML(vid,qty){return '<div class="zh-qty" data-zh-qty data-variant-id="'+vid+'"><button type="button" class="zh-qty__btn zh-qty__plus" data-zh-plus aria-label="+">+</button><span class="zh-qty__n" data-zh-n>'+qty+'</span><button type="button" class="zh-qty__btn zh-qty__trash" data-zh-trash aria-label="حذف">'+TRASH_SVG+'</button></div>';}
function frag(html){var d=document.createElement('div');d.innerHTML=html;return d.firstChild;}
/* Starts (or reuses) this variant's cart line and captures its real line
   key -- /cart/change.js needs the exact key when a line carries properties,
   a bare variant id gets rejected with a 400. */
function startLine(vid){
  var p=fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:1}]})})
    .then(function(r){return r.json();})
    .then(function(data){var item=data&&data.items&&data.items[0];var key=item?item.key:null;lineKey[vid]=key;return key;})
    .catch(function(){return null;});
  pendingAdd[vid]=p;
  return p;
}
/* This store re-issues a fresh key for a line on every cart mutation (the
   key submitted to /cart/change.js is not the one it returns), so a key
   cached once and reused across several calls goes stale and gets rejected
   with a 400. Fix: always resolve to whatever key is currently known --
   lineKey[vid] once the line exists, otherwise the in-flight add -- and
   always overwrite lineKey[vid] with the fresh key each response hands back
   before the next call can use it. */
function getKey(vid){
  if(lineKey[vid])return Promise.resolve(lineKey[vid]);
  return pendingAdd[vid]||startLine(vid);
}
function sendChange(vid,qty){
  return getKey(vid).then(function(key){
    if(!key)return;
    return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(data){
        if(qty<=0){lineKey[vid]=null;return;}
        var item=data&&data.items&&data.items.filter(function(it){return String(it.variant_id)===String(vid);}).pop();
        lineKey[vid]=item?item.key:key;
      })
      .catch(function(){});
  });
}
/* Collapse rapid +/- into a single request per line (matches
   zz-cart-speed.liquid's debounceSend for the cart drawer's own buttons --
   same store, same key-rotation quirk, same fix). */
function debounceChange(vid,qty){
  if(timers[vid])clearTimeout(timers[vid]);
  timers[vid]=setTimeout(function(){delete timers[vid];sendChange(vid,qty);},300);
}
/* Trash is decisive: cancel any queued +/- for this line and remove now. */
function immediateChange(vid,qty){
  if(timers[vid]){clearTimeout(timers[vid]);delete timers[vid];}
  return sendChange(vid,qty);
}

/* Instant, optimistic UI: the stepper appears immediately on click and every
   +/trash updates it immediately; the network call runs in the background
   and is never waited on. No cloned image, no animation, nothing that could
   feel slow. */
document.addEventListener('click',function(e){
  var addBtn=e.target&&e.target.closest?e.target.closest('.zilzal-hero-wrapper [data-zh-add]'):null;
  if(addBtn){
    var card=addBtn.closest('[data-zh-card]')||addBtn.closest('.zh-card');
    if(card&&!card.classList.contains('is-active'))return;
    e.preventDefault();e.stopImmediatePropagation();
    var vid=addBtn.getAttribute('data-variant-id');if(!vid)return;
    addLabel[vid]=addBtn.textContent;
    addBtn.replaceWith(frag(qtyHTML(vid,1)));
    startLine(vid);
    if(window.zzCartRefresh)window.zzCartRefresh();
    return;
  }
  var plusBtn=e.target&&e.target.closest?e.target.closest('.zilzal-hero-wrapper [data-zh-plus]'):null;
  if(plusBtn){
    e.preventDefault();e.stopImmediatePropagation();
    var wrap=plusBtn.closest('[data-zh-qty]');if(!wrap)return;
    var n=wrap.querySelector('[data-zh-n]');
    var next=(parseInt(n.textContent,10)||1)+1;
    n.textContent=next;
    debounceChange(wrap.getAttribute('data-variant-id'),next);
    return;
  }
  var trashBtn=e.target&&e.target.closest?e.target.closest('.zilzal-hero-wrapper [data-zh-trash]'):null;
  if(trashBtn){
    e.preventDefault();e.stopImmediatePropagation();
    var wrap2=trashBtn.closest('[data-zh-qty]');if(!wrap2)return;
    var vid2=wrap2.getAttribute('data-variant-id');
    wrap2.replaceWith(frag(addBtnHTML(vid2,addLabel[vid2]||'أضف للسلة')));
    immediateChange(vid2,0);
    return;
  }
},true);

/* Reflect items already in the cart on load, so a returning visitor sees the
   stepper (with the real quantity) instead of "Add" for products they've
   already added. One background request; never blocks first paint. */
function syncFromCart(){
  var buttons=document.querySelectorAll('.zilzal-hero-wrapper [data-zh-add]');
  if(!buttons.length)return;
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
    var lineByVariant={};
    (cart.items||[]).forEach(function(it){
      var l=lineByVariant[it.variant_id];
      if(l){l.quantity+=it.quantity;} else {lineByVariant[it.variant_id]={quantity:it.quantity,key:it.key};}
    });
    Array.prototype.forEach.call(buttons,function(btn){
      var vid=btn.getAttribute('data-variant-id');
      var l=lineByVariant[vid];
      if(!l)return;
      addLabel[vid]=btn.textContent;
      lineKey[vid]=l.key; // already known -- +/trash won't re-add
      btn.replaceWith(frag(qtyHTML(vid,l.quantity)));
    });
  }).catch(function(){});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',syncFromCart);else syncFromCart();
})();

;
/* ---- from sections/zz-fixes.liquid (delivery token) ---- */
(function(){
function gc(n){var a=document.cookie.split(';');for(var i=0;i<a.length;i++){var p=a[i].replace(/^ +/,'');if(p.indexOf(n+'=')===0)return p.substring(n.length+1);}return '';}
function sc(n,v){var d=new Date();d.setTime(d.getTime()+2592000000);var h=location.hostname.split('.');var base=h.length>1?h.slice(-2).join('.'):location.hostname;document.cookie=n+'='+v+';expires='+d.toUTCString()+';path=/;domain=.'+base+';secure;samesite=lax';}
function uuid(){if(window.crypto&&crypto.randomUUID){return crypto.randomUUID();}return 'zz-'+Date.now()+'-'+Math.random().toString(16).slice(2)+Math.random().toString(16).slice(2);}
var tok=gc('delivery_token');
if(!tok){tok=uuid();sc('delivery_token',tok);}
/* Speed (Oct 2026): this wrote the token into the cart on EVERY page view (a cart write the other cart
   scripts then reacted to). It now reads the cart first — the same read the cart pill makes anyway, so
   it is shared, not an extra request — and writes only when the cart does not carry this token yet. */
function post(){fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{delivery_token:tok}})}).catch(function(){});}
/* Speed (Oct 2026): the token is only needed at checkout, so it is written once the cart holds an item
   (first page view with items, or the moment the first item is added). A visitor who only browses never
   triggers a cart write. */
var posted=false;function need(c){return c&&c.item_count>0&&!(c.attributes&&c.attributes.delivery_token===tok);}
function run(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){if(need(c)&&!posted){posted=true;post();}}).catch(function(){});}
document.addEventListener('zz:cart',function(e){if(need(e.detail)&&!posted){posted=true;post();}});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

;
/* ---- from sections/zz-rewards-bar.liquid ---- */
(function () {
  /* speed ≈ 50px per second whatever the text length/language */
  var t = document.querySelector('[data-zzrw-track]'); if (!t) return;
  if (getComputedStyle(t).direction === 'rtl') t.classList.add('is-rtl');
  function set() { var w = t.firstElementChild ? t.firstElementChild.getBoundingClientRect().width : 0; if (w > 0) t.style.setProperty('--zzrw-dur', Math.max(20, Math.round(w / 50)) + 's'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', set); else set();
  window.addEventListener('load', set);
})();

;
/* ---- from sections/zz-menu.liquid ---- */
(function(){
  var overlay = document.getElementById('zzmenu-overlay');
  var menu = document.getElementById('zzmenu');
  var picker = document.getElementById('zzgamepick');
  if (!overlay || !menu) return;

  function closeNative(){ try { var d = document.getElementById('Details-menu-drawer-container'); if (d) d.removeAttribute('open'); document.querySelectorAll('.menu-drawer-container[open]').forEach(function(x){ x.removeAttribute('open'); }); document.body.classList.remove('menu-open'); } catch(e){} }
  function open(){ menu.classList.add('is-open'); overlay.classList.add('is-open'); menu.setAttribute('aria-hidden','false'); document.body.classList.add('zzmenu-active'); document.documentElement.style.overflow='hidden'; closeNative(); }
  function close(){ menu.classList.remove('is-open'); overlay.classList.remove('is-open'); menu.setAttribute('aria-hidden','true'); document.body.classList.remove('zzmenu-active'); document.documentElement.style.overflow=''; menu.querySelectorAll('.zzm__loc-field.is-open').forEach(function(f){ f.classList.remove('is-open'); }); }
  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
  Array.prototype.forEach.call(menu.querySelectorAll('[data-zzmenu-close]'), function(b){ b.addEventListener('click', close); });
  Array.prototype.forEach.call(menu.querySelectorAll('a[href]'), function(a){ a.addEventListener('click', function(){ setTimeout(close, 30); }); });
  Array.prototype.forEach.call(menu.querySelectorAll('[data-zzloc-toggle]'), function(btn){ btn.addEventListener('click', function(e){ e.stopPropagation(); var field = btn.parentNode; var isOpen = field.classList.contains('is-open'); menu.querySelectorAll('.zzm__loc-field.is-open').forEach(function(f){ f.classList.remove('is-open'); }); if (!isOpen) field.classList.add('is-open'); }); });
  menu.addEventListener('click', function(e){ if (!e.target.closest('.zzm__loc-field')) { menu.querySelectorAll('.zzm__loc-field.is-open').forEach(function(f){ f.classList.remove('is-open'); }); } });
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var trg = e.target.closest('summary.header__icon--menu, .header__icon--menu, .menu-drawer-container > summary, header-drawer summary, [aria-label="Menu"], [aria-label="menu"], [aria-label="القائمة"]');
    if (!trg || menu.contains(trg)) return;
    e.preventDefault(); e.stopImmediatePropagation(); open();
  }, true);

  /* ---------- Move the game picker into the header, beside the logo ---------- */
  function placePicker(){
    if (!picker) return;
    if (picker.parentNode && picker.parentNode.closest && picker.parentNode.closest('#header-group, #header-component, .header-section')) return;
    var logo = document.querySelector('#header-component .header__logo, #header-component .header__heading, #header-component .header__heading-link, .header-section .header__logo, .header-section .header__heading');
    var host = null, ref = null;
    if (logo) {
      var col = logo.closest('.header__column') || logo.parentNode;
      host = col && col.parentNode ? col.parentNode : null;
      ref = col ? col.nextSibling : null;
      if (!host) { host = logo.parentNode; ref = logo.nextSibling; }
    }
    if (!host) host = document.querySelector('#header-component .header__column--left') || document.querySelector('#header-component header-actions');
    if (!host) return;
    picker.hidden = false;
    if (ref) host.insertBefore(picker, ref); else host.appendChild(picker);
    markCurrent();
  }

  /* Reflect the collection being viewed, so the chip is a state indicator and
     not just a menu. */
  function markCurrent(){
    if (!picker) return;
    if (picker.querySelector('.zzgp__item.is-current')) return;   /* already set on the server */
    var path = decodeURIComponent(window.location.pathname);
    var items = picker.querySelectorAll('[data-zzgp-url]');
    for (var i = 0; i < items.length; i++) {
      var url = decodeURIComponent(items[i].getAttribute('data-zzgp-url') || '');
      if (!url) continue;
      var handle = url.split('/collections/')[1];
      if (!handle) continue;
      handle = handle.split('?')[0].split('#')[0];
      if (handle && path.indexOf(handle) !== -1) {
        items[i].classList.add('is-current');
        var lbl = picker.querySelector('[data-zzgp-label]');
        var thumb = picker.querySelector('[data-zzgp-thumb]');
        var name = items[i].querySelector('span:last-child');
        var img = items[i].querySelector('img');
        if (lbl && name) lbl.textContent = name.textContent;
        if (thumb && img) thumb.innerHTML = '<img src="' + img.getAttribute('src') + '" alt="">';
        break;
      }
    }
  }

  /* Oct 2026: the "more games below" fade in the picker hides once the list is scrolled to the end.
     On phones the list is moved out of the picker into a bottom sheet, so it is looked up globally. */
  function zzPanelEnd(p){
    try {
      var pnl = p || document.querySelector('.zzgp__panel');
      if (!pnl) return;
      pnl.classList.toggle('zz-at-end', pnl.scrollTop + pnl.clientHeight >= pnl.scrollHeight - 6);
    } catch(e){}
  }
  document.addEventListener('scroll', function(e){
    var t = e.target;
    if (t && t.classList && t.classList.contains('zzgp__panel')) zzPanelEnd(t);
  }, { capture:true, passive:true });
  if (picker) picker.addEventListener('click', function(){ requestAnimationFrame(function(){ zzPanelEnd(); }); });

  if (picker) {
    picker.addEventListener('click', function(e){
      var t = e.target.closest('[data-zzgp-toggle]');
      if (!t) return;
      e.preventDefault(); e.stopPropagation();
      var openNow = picker.classList.toggle('is-open');
      t.setAttribute('aria-expanded', openNow ? 'true' : 'false');
    });
    document.addEventListener('click', function(e){
      if (picker.classList.contains('is-open') && !e.target.closest('#zzgamepick')) picker.classList.remove('is-open');
    });
  }

  function hideStatus(){ try { document.querySelectorAll('.zz-status').forEach(function(el){ el.style.setProperty('display','none','important'); }); } catch(e){} }
  /* Desktop currency selector.
     Oct 2026 #3: BUCKS is gone; this chip is the theme's own picker, drawn and run by
     assets/zz-currency.js (window.zzCurDraw). One node is kept for the whole visit and put back if the
     header is ever re-rendered; it is appended LAST so a re-render only removes it, CSS order:-1 keeps
     it visually first. */
  var zzCurWrap = null;
  function zzCurEsc(s){ return String(s).replace(/[&<>"']/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]; }); }
  function placeCurDesktop(){
    try {
      /* Speed (Oct 2026): a media query instead of window.innerWidth (no forced layout on phones). */
      if (window.matchMedia ? !window.matchMedia('(min-width: 750px)').matches : (window.innerWidth || 0) < 750) return;
      var host = document.querySelector('#header-component .header__column--right') || document.querySelector('#header-component header-actions') || document.querySelector('.header-section header-actions');
      if (!host) return;
      if (zzCurWrap && zzCurWrap.parentNode === host) return;
      if (!zzCurWrap) {
        var lbl = document.documentElement.getAttribute('data-zz-cur-l') || '';
        zzCurWrap = document.createElement('div');
        zzCurWrap.className = 'zz-cur-desktop';
        zzCurWrap.setAttribute('data-zz-cur-field', '');
        zzCurWrap.innerHTML = '<button type="button" class="zz-cur__btn" data-zz-cur-toggle aria-haspopup="true" aria-expanded="false" aria-label="' + zzCurEsc(lbl) + '">'
          + '<span data-zz-cur-label="code">' + zzCurEsc(document.documentElement.getAttribute('data-zz-cur') || 'SAR') + '</span>'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg></button>'
          + '<div class="zz-cur__panel" data-zz-cur-list></div>';
      }
      host.appendChild(zzCurWrap);
      if (window.zzCurDraw) window.zzCurDraw();
    } catch(e){}
  }

  function boot(){ hideStatus(); placeCurDesktop(); placePicker(); }
  boot();
  window.addEventListener('load', boot);
  setTimeout(boot, 500);
  setTimeout(boot, 1500);
  window.addEventListener('resize', function(){ clearTimeout(window.__zzBootR); window.__zzBootR = setTimeout(boot, 250); });
  try { var hg = document.getElementById('header-group'); if (hg) new MutationObserver(boot).observe(hg, { childList:true, subtree:true }); } catch(e){}

  function fixHeaderOverlap(){
    try {
      var main = document.getElementById('MainContent');
      if (!main || main.getAttribute('data-template') !== 'index') { if (main) main.style.paddingTop=''; return; }
      var cands = document.querySelectorAll('#header-component, .header-section .header, header.header, #header-group header');
      var maxBottom = 0;
      Array.prototype.forEach.call(cands, function(el){ if (!el) return; var cs = getComputedStyle(el); if (cs.position !== 'fixed' && cs.position !== 'absolute') return; var r = el.getBoundingClientRect(); if (r.top > 130 || r.height < 20) return; if (r.bottom > maxBottom) maxBottom = r.bottom; });
      if (maxBottom > 0) main.style.paddingTop = Math.round(maxBottom) + 'px';
    } catch(e){}
  }
  /* first measure on the next frame (before it is painted) instead of mid-page: measuring here made the
     browser lay out the half-loaded page while it was still reading it */
  /* Oct 2026: every link to the reviews page (header, side menu, footer, product rating, home buttons, any
     language) lands on the reviews list (#reviews) instead of the top of the page. A link marked
     data-zz-keep (the "كيف تثق بنا؟" button) still opens the page at the top, where that section is. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hash || a.hasAttribute('data-zz-keep') || a.origin !== location.origin) return;
    if (/\/pages\/reviews\/?$/.test(a.pathname)) a.hash = 'reviews';
  }, true);
  (window.requestAnimationFrame || setTimeout)(fixHeaderOverlap); window.addEventListener('load', fixHeaderOverlap); window.addEventListener('resize', fixHeaderOverlap);
  /* Speed (Oct 2026): re-measure when the header's own size changes (fonts, hydration) instead of on two blind timers */
  try { var hc = document.getElementById('header-component'); if (hc && 'ResizeObserver' in window) new ResizeObserver(function () { requestAnimationFrame(fixHeaderOverlap); }).observe(hc); else { setTimeout(fixHeaderOverlap, 400); setTimeout(fixHeaderOverlap, 1200); } } catch (e) { setTimeout(fixHeaderOverlap, 400); setTimeout(fixHeaderOverlap, 1200); }
})();

;
/* ---- from snippets/zz-menu.liquid (1) ---- */
  (function () {
    function parseOpt(o) {
      var t = (o.textContent || '').trim();
      var paren = t.indexOf('(');
      if (paren !== -1) t = t.slice(0, paren).trim();
      var parts = t.split('—');
      if (parts.length < 2) parts = t.split('–');
      if (parts.length < 2) parts = t.split(' - ');
      if (parts.length >= 2) return { n: parts[0].trim(), p: parts.slice(1).join(' ').trim() };
      return { n: t, p: '' };
    }
    function enhance(sel) {
      if (sel.__zzVbtns) return;
      sel.__zzVbtns = true;
      sel.classList.add('bxp-enhanced');
      /* Speed (Oct 2026): sections/product-bxc.liquid draws the buttons itself (no jump when the page is shown);
         here they only get their click handlers. A select without buttons still gets them built as before. */
      var wrap = sel.nextElementSibling;
      var drawn = !!(wrap && wrap.classList && wrap.classList.contains('bxp-vbtns'));
      if (!drawn) {
        wrap = document.createElement('div');
        wrap.className = 'bxp-vbtns';
        wrap.setAttribute('role', 'radiogroup');
      }
      Array.prototype.forEach.call(sel.options, function (o, i) {
        var info = parseOpt(o);
        var btn = drawn ? wrap.children[i] : document.createElement('button');
        if (!btn) return;
        if (drawn) {
          btn.addEventListener('click', function () {
            if (o.disabled) return;
            sel.value = o.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            Array.prototype.forEach.call(wrap.children, function (b) {
              b.classList.remove('is-sel');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('is-sel');
            btn.setAttribute('aria-checked', 'true');
          });
          return;
        }
        btn.type = 'button';
        btn.className = 'bxp-vbtn' + (o.selected ? ' is-sel' : '') + (o.disabled ? ' is-soldout' : '');
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', o.selected ? 'true' : 'false');
        if (o.disabled) btn.setAttribute('aria-disabled', 'true');
        var ns = document.createElement('span');
        ns.className = 'bxp-vbtn__n';
        ns.textContent = info.n;
        btn.appendChild(ns);
        if (info.p) {
          var ps = document.createElement('span');
          ps.className = 'bxp-vbtn__p';
          ps.textContent = info.p;
          btn.appendChild(ps);
        }
        btn.addEventListener('click', function () {
          if (o.disabled) return;
          sel.value = o.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          Array.prototype.forEach.call(wrap.children, function (b) {
            b.classList.remove('is-sel');
            b.setAttribute('aria-checked', 'false');
          });
          btn.classList.add('is-sel');
          btn.setAttribute('aria-checked', 'true');
        });
        wrap.appendChild(btn);
      });
      if (!drawn && sel.parentNode) sel.parentNode.insertBefore(wrap, sel.nextSibling);
    }
    function run() {
      Array.prototype.forEach.call(document.querySelectorAll('select.bxp-select[data-bxp-variant]'), enhance);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

;
/* ---- from snippets/zz-menu.liquid (2) ---- */
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.bxp-rel [data-bxc-add]');
      if (!btn || btn.disabled) return;
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-done')) return;
      var vid = btn.getAttribute('data-vid');
      if (!vid) return;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      }).then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-done');
        setTimeout(function () { btn.classList.remove('is-done'); }, 1200);
        document.dispatchEvent(new CustomEvent('cart:added'));
      }).catch(function () {
        btn.classList.remove('is-loading');
      });
    });
  })();

;
/* ---- from snippets/zz-cart-speed.liquid ---- */
(function () {
  var root  = document.getElementById('zzfc-root');
  var sheet = document.getElementById('zzcart');
  if (!sheet) return;
  var cartUrl = (root && root.getAttribute('data-cart-url')) || '/cart';

  function rows() { return sheet.querySelectorAll('.zzcart__item'); }

  function syncCounts() {
    var rs = rows(), n = 0;
    for (var i = 0; i < rs.length; i++) {
      var qn = rs[i].querySelector('.zzcart__qn');
      n += parseInt(qn && qn.textContent, 10) || 0;
    }
    var sc = sheet.querySelector('[data-zzcart-count]'); if (sc) sc.textContent = n;
    if (window.zzCartFx) window.zzCartFx.count(n);   /* the pill's count is an animated odometer now */
    else { var fc = root && root.querySelector('[data-zzfc-count]'); if (fc) fc.textContent = n; }
    sheet.setAttribute('data-empty', rs.length ? 'false' : 'true');
    if (root) root.setAttribute('data-empty', n > 0 ? 'false' : 'true');
  }

  function removeRow(row) {
    row.style.overflow = 'hidden';
    row.style.maxHeight = row.offsetHeight + 'px';
    row.style.transition = 'opacity .15s ease, transform .15s ease, max-height .22s ease, margin .22s ease, padding .22s ease';
    requestAnimationFrame(function () {
      row.style.opacity = '0';
      row.style.transform = 'translateX(28px)';
      row.style.maxHeight = '0';
      row.style.marginTop = '0'; row.style.marginBottom = '0';
      row.style.paddingTop = '0'; row.style.paddingBottom = '0';
    });
    setTimeout(function () { if (row.parentNode) row.parentNode.removeChild(row); syncCounts(); }, 220);
  }

  // Serialize writes so concurrent changes can't race the Cart API.
  var chain = Promise.resolve();
  function send(key, qty) {
    chain = chain.then(function () {
      return fetch(cartUrl + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: qty })
      }).catch(function () {});
    });
    return chain;
  }

  // Collapse rapid +/- on the same line into a single request.
  var timers = {};
  function debounceSend(key, qty) {
    if (timers[key]) clearTimeout(timers[key]);
    timers[key] = setTimeout(function () { delete timers[key]; send(key, qty); }, 300);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-zzremove],[data-zzplus],[data-zzminus]');
    if (!btn || !sheet.contains(btn)) return;
    var row = btn.closest('.zzcart__item'); if (!row) return;
    var key = row.getAttribute('data-key'); if (!key) return;

    // Min-order items: defer to the cart's own server-confirmed handler
    // (no optimistic flash below the minimum; price updates with the quantity).
    if (window.__zzMinForKey && window.__zzMinForKey(key) > 0) return;

    // Take over from the inline handler (skips its network-wait + is-busy dim).
    e.preventDefault();
    e.stopImmediatePropagation();

    var qn = row.querySelector('.zzcart__qn');
    var cur = parseInt(qn && qn.textContent, 10) || 1;

    if (btn.matches('[data-zzremove]')) { removeRow(row); send(key, 0); return; }

    var target = btn.matches('[data-zzplus]') ? cur + 1 : Math.max(0, cur - 1);
    if (target === 0) { removeRow(row); send(key, 0); return; }

    if (qn) qn.textContent = target;
    syncCounts();
    debounceSend(key, target);
  }, true);
})();

;
/* ---- from snippets/zz-cart-trust.liquid ---- */
(function(){
  function inject(){
    var foot=document.querySelector('#zzcart .zzcart__foot');
    if(!foot){return false;}
    if(foot.querySelector('[data-zzct]')){return true;}
    var co=foot.querySelector('.zzcart__checkout');
    var tpl=document.getElementById('zzct-tpl');
    if(!co||!tpl||!tpl.content||!tpl.content.firstElementChild){return false;}
    co.parentNode.insertBefore(tpl.content.firstElementChild.cloneNode(true),co);
    return true;
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',inject);}else{inject();}
  var n=0,iv=setInterval(function(){if(inject()||++n>20){clearInterval(iv);}},300);
})();

;
/* ---- from snippets/zz-loading.liquid ---- */
  (function () {
    var root = document.documentElement;
    root.classList.add('zz-ldjs');

    function mark(el) {
      if (!el || el.tagName !== 'IMG') return;
      el.classList.add('zz-ld');
      /* the picture's frame is marked too, so the shimmer CSS needs no :has() */
      var box = el.closest && el.closest('.bxc-card__media, .bxp-main, .bxp-thumb');
      if (box) box.classList.add('zz-ld');
    }
    document.addEventListener('load', function (e) { mark(e.target); }, true);
    document.addEventListener('error', function (e) { mark(e.target); }, true);
    function sweep() {
      var imgs = document.images;
      for (var i = 0; i < imgs.length; i++) { if (imgs[i].complete) mark(imgs[i]); }
    }
    sweep();
    document.addEventListener('DOMContentLoaded', sweep);
    window.addEventListener('load', sweep);

    /* card skeletons shimmer only near the screen (see the CSS note above) */
    if ('IntersectionObserver' in window) {
      root.classList.add('zz-io');
      var io = new IntersectionObserver(function (es) {
        for (var i = 0; i < es.length; i++) es[i].target.classList.toggle('zz-on', es[i].isIntersecting);
      }, { rootMargin: '200px 0px' });
      var watch = function () {
        var els = document.querySelectorAll('.bxc-card__media');
        for (var i = 0; i < els.length; i++) { if (!els[i].__zzIo) { els[i].__zzIo = 1; io.observe(els[i]); } }
      };
      watch();
      document.addEventListener('DOMContentLoaded', watch);
      window.addEventListener('load', watch);
      document.addEventListener('shopify:section:load', watch);
    }

    var bar = document.createElement('div');
    bar.className = 'zz-navbar';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);

    var stopTimer = null;
    function stop() { root.classList.remove('zz-nav'); clearTimeout(stopTimer); }
    document.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || a.hasAttribute('download')) return;
      if (a.target && a.target !== '_self') return;
      var u;
      try { u = new URL(a.href, location.href); } catch (x) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.search === location.search) return;
      /* decide after every other click handler ran: if one cancelled the navigation, no bar */
      setTimeout(function () {
        if (e.defaultPrevented) return;
        root.classList.add('zz-nav');
        clearTimeout(stopTimer);
        stopTimer = setTimeout(stop, 12000);
      }, 0);
    });
    window.addEventListener('pageshow', stop);
  })();

  /* Variant buttons (built by snippets/zz-menu.liquid from the <option> text):
     the currency app rewrites the options AFTER the buttons copy them, so the
     buttons kept the shop currency. Repaint them whenever the options change. */
  (function () {
    function parseOpt(o) {
      var t = (o.textContent || '').trim();
      var paren = t.indexOf('(');
      if (paren !== -1) t = t.slice(0, paren).trim();
      var parts = t.split('\u2014');
      if (parts.length < 2) parts = t.split('\u2013');
      if (parts.length < 2) parts = t.split(' - ');
      if (parts.length >= 2) return { n: parts[0].trim(), p: parts.slice(1).join(' ').trim() };
      return { n: t, p: '' };
    }
    function hook(sel) {
      if (sel.__zzRepaint) return;
      var wrap = sel.nextElementSibling;
      if (!wrap || !wrap.classList.contains('bxp-vbtns')) return;
      sel.__zzRepaint = true;
      function repaint() {
        Array.prototype.forEach.call(sel.options, function (o, i) {
          var btn = wrap.children[i];
          if (!btn) return;
          var info = parseOpt(o);
          var ns = btn.querySelector('.bxp-vbtn__n');
          if (ns && ns.textContent !== info.n) ns.textContent = info.n;
          var ps = btn.querySelector('.bxp-vbtn__p');
          if (info.p) {
            if (!ps) { ps = document.createElement('span'); ps.className = 'bxp-vbtn__p'; btn.appendChild(ps); }
            if (ps.textContent !== info.p) ps.textContent = info.p;
          }
        });
      }
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(repaint).observe(sel, { childList: true, subtree: true, characterData: true });
      }
      [400, 1200, 2500].forEach(function (ms) { setTimeout(repaint, ms); });
      window.addEventListener('load', repaint);
      repaint();
    }
    function run() {
      Array.prototype.forEach.call(document.querySelectorAll('select.bxp-select.bxp-enhanced'), hook);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
    } else {
      setTimeout(run, 0);
    }
    document.addEventListener('shopify:section:load', function () { setTimeout(run, 0); });
  })();

;
/* ---- from snippets/zz-fastnav.liquid ---- */
(function () {
  if (window.__zzFastNav) return;
  window.__zzFastNav = true;
  var root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  var KEY = 'zzPimgRect';
  var RTL = (root.getAttribute('dir') || document.dir || 'rtl') === 'rtl';
  function vw() { return root.clientWidth || window.innerWidth || 0; }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }

  /* ---------- 1a. product page: remember where the picture and the title are ---------- */
  function save() {
    var img = document.getElementById('zz-pimg');
    if (!img) return;
    var box = img.closest('.bxp-main') || img;
    var y = window.scrollY || 0;
    var r = box.getBoundingClientRect();
    if (r.width < 40) return;
    var info = document.querySelector('.bxp-info h1') || document.querySelector('.bxp-info');
    var ir = info ? info.getBoundingClientRect() : null;
    var bar = document.querySelector('.zzrw-bar');
    var br = bar ? bar.getBoundingClientRect() : null;
    var hdr = document.getElementById('header-component');
    var hr = hdr ? hdr.getBoundingClientRect() : null;
    var rec = {
      w: vw(),
      l: Math.round(r.left), t: Math.round(r.top + y), s: Math.round(r.width), h: Math.round(r.height),
      il: ir ? Math.round(ir.left) : Math.round(r.left), it: ir ? Math.round(ir.top + y) : Math.round(r.bottom + y + 16),
      iw: ir ? Math.round(ir.width) : Math.round(r.width),
      bar: (br && br.top + y < 4) ? Math.round(br.height) : 0,
      hb: hr ? Math.round(hr.bottom + y) : 0
    };
    var all = load();
    var keys = Object.keys(all);
    if (keys.length > 6) delete all[keys[0]];
    all[rec.w] = rec;
    try { localStorage.setItem(KEY, JSON.stringify(all)); } catch (e) {}
  }
  if (document.getElementById('zz-pimg')) {
    var saveSoon = function () { setTimeout(function () { requestAnimationFrame(save); }, 300); };
    if (document.readyState === 'complete') saveSoon(); else window.addEventListener('load', saveSoon);
    var rT;
    window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(save, 400); });
  }

  /* where the product picture will be on this screen width */
  function target() {
    var all = load(), w = vw();
    if (all[w]) return all[w];
    if (w >= 750) return null;
    /* phones: same header everywhere, the picture width follows the screen width */
    var best = null;
    Object.keys(all).forEach(function (k) { var r = all[k]; if (r && r.w < 750 && (!best || Math.abs(r.w - w) < Math.abs(best.w - w))) best = r; });
    if (best) {
      var d = w - best.w;
      return { w: w, l: best.l, t: best.t, s: best.s + d, h: best.h + d, il: best.il, it: best.it + d, iw: best.iw + d, bar: best.bar, hb: best.hb };
    }
    return { w: w, l: 36, t: 219, s: w - 72, h: w - 72, il: 36, it: w + 162, iw: w - 72, bar: 32, hb: 125 };
  }

  /* ---------- 1b. tap on a product card: move its picture into place right away ---------- */
  var overlay = null, killT = null;
  function clear() {
    clearTimeout(killT);
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
    overlay = null;
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) clear(); });

  function cardImage(a) {
    var img = a.querySelector('img');
    if (!img) {
      var card = a.closest('.bxc-card, product-card, .product-card, .resource-card');
      img = card && card.querySelector('img');
    }
    if (!img) return null;
    var r = img.getBoundingClientRect();
    if (r.width < 40 || r.height < 40 || r.bottom < 0 || r.top > window.innerHeight) return null;
    return { img: img, r: r };
  }

  function el(cls, css) { var d = document.createElement('div'); d.className = cls; if (css) d.style.cssText = css; return d; }

  function show(hit, rec) {
    clear();
    var y = window.scrollY || 0;
    var top = (y < 6 && rec.hb) ? rec.hb : 0; /* page at the very top: keep the real header visible */
    var ov = el('');
    ov.id = 'zz-fastnav';
    ov.setAttribute('aria-hidden', 'true');
    ov.style.top = top + 'px';
    ov.appendChild(el('zzfn-bg'));
    if (!top && rec.bar) ov.appendChild(el('zzfn-bar', 'height:' + rec.bar + 'px'));

    /* title + price placeholders where the product page prints them */
    var bw1 = Math.round(rec.iw * 0.72), bw2 = Math.round(rec.iw * 0.38);
    function bx(w) { return RTL ? rec.il + rec.iw - w : rec.il; }
    ov.appendChild(el('zzfn-sk', 'left:' + bx(bw1) + 'px;top:' + (rec.it - top) + 'px;width:' + bw1 + 'px;height:24px'));
    ov.appendChild(el('zzfn-sk', 'left:' + bx(bw2) + 'px;top:' + (rec.it - top + 42) + 'px;width:' + bw2 + 'px;height:20px'));

    var box = el('zzfn-box', 'left:' + rec.l + 'px;top:' + (rec.t - top) + 'px;width:' + rec.s + 'px;height:' + rec.h + 'px');
    var im = document.createElement('img');
    im.alt = '';
    im.decoding = 'sync';
    im.src = hit.img.currentSrc || hit.img.src;
    box.appendChild(im);
    var r = hit.r;
    box.style.transform = 'translate(' + (r.left - rec.l) + 'px,' + (r.top - rec.t) + 'px) scale(' + (r.width / rec.s) + ',' + (r.height / rec.h) + ')';
    ov.appendChild(box);

    /* the overlay picture is now the one that morphs into the product page picture */
    document.querySelectorAll('[data-view-transition-triggered]').forEach(function (x) { x.removeAttribute('data-view-transition-triggered'); });
    if (hit.img.getAttribute('data-view-transition-type') === 'product-image-transition') hit.img.removeAttribute('data-view-transition-type');
    im.setAttribute('data-view-transition-type', 'product-image-transition');
    im.setAttribute('data-view-transition-triggered', '');

    document.body.appendChild(ov);
    overlay = ov;
    void box.offsetWidth;
    ov.classList.add('is-on');
    box.style.transform = 'none';
    /* navigation stalled or cancelled: give the page back */
    killT = setTimeout(clear, 10000);
  }

  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a || a.hasAttribute('download') || (a.target && a.target !== '_self')) return;
    if (a.closest('#zzcart, #zzmenu, #zz-fastnav, .zzgp, [data-zz-no-fastnav]')) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.origin !== location.origin || u.pathname === location.pathname) return;
    var hit = cardImage(a);
    if (!hit) return;
    var src = hit.img.currentSrc || hit.img.src || '';
    if (/^https:/.test(src)) {
      /* the product page shows this cached copy at once, and the full-size picture starts loading now */
      try { sessionStorage.setItem('zzPimgSrc', JSON.stringify({ p: u.pathname, s: src })); } catch (x) {}
      if (/[?&]width=\d+/.test(src)) {
        [900, 440].forEach(function (w) { var pre = new Image(); pre.src = src.replace(/([?&])width=\d+/, '$1width=' + w); });
      }
    }
    var rec = target();
    if (!rec) return;
    show(hit, rec);
  });

  /* ---------- 1c. any other page: a light skeleton while it loads ----------
     Only appears if the next page is not on screen within 120 ms (prefetched pages open
     before that, so they never flash it). Cleared by the browser's Back (page cache) too. */
  var skel = null, skelT = null, skelKill = null;
  function clearSkel() {
    clearTimeout(skelT); clearTimeout(skelKill);
    if (skel && skel.parentNode) skel.parentNode.removeChild(skel);
    skel = null;
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) clearSkel(); });
  /* skeleton already on screen: let the next page replace it directly. The theme's page
     cross-fade would otherwise start from a picture of the OLD page (the skeleton is not in
     it), so the old page would flash back for a moment before the new one. */
  window.addEventListener('pageswap', function (e) {
    if (skel && skel.isConnected && e.viewTransition) { try { e.viewTransition.skipTransition(); } catch (x) {} }
  });
  function rep(html, n) { var o = ''; for (var i = 0; i < n; i++) o += html; return o; }
  function showSkel(kind) {
    clearSkel();
    var hdr = document.getElementById('header-component');
    var top = 0;
    if (hdr) { var hb = hdr.getBoundingClientRect().bottom; if (hb > 0) top = Math.round(hb); }
    var el = document.createElement('div');
    el.id = 'zz-pageskel';
    el.setAttribute('aria-hidden', 'true');
    el.style.top = top + 'px';
    var wide = vw() >= 750;
    var cards = rep('<div class="zzps-card"></div>', wide ? 12 : 6);
    var html;
    if (kind === 'grid') {
      html = '<div class="zzps-b" style="height:42px"></div><div class="zzps-row">' + rep('<div class="zzps-pill"></div>', 6) + '</div><div class="zzps-grid">' + cards + '</div>';
    } else if (kind === 'home') {
      html = '<div class="zzps-b" style="height:' + (wide ? 300 : 190) + 'px;border-radius:16px"></div><div class="zzps-b" style="height:22px;width:40%"></div><div class="zzps-grid">' + cards + '</div>';
    } else if (kind === 'product') {
      html = '<div class="zzps-b" style="height:40px;width:60%"></div><div class="zzps-prod"><div class="zzps-b" style="aspect-ratio:1/1;border-radius:20px"></div><div style="display:flex;flex-direction:column;gap:12px"><div class="zzps-b" style="height:30px;width:70%"></div><div class="zzps-b" style="height:26px;width:35%"></div><div class="zzps-b" style="height:90px"></div><div class="zzps-b" style="height:50px"></div></div></div>';
    } else {
      html = '<div class="zzps-b" style="height:34px;width:55%"></div>' + rep('<div class="zzps-b" style="height:16px"></div>', 6) + '<div class="zzps-b" style="height:16px;width:65%"></div><div class="zzps-b" style="height:180px;border-radius:16px"></div>';
    }
    el.innerHTML = '<div class="zzps">' + html + '</div>';
    document.body.appendChild(el);
    skel = el;
    void el.offsetWidth;
    el.classList.add('is-on');
    skelKill = setTimeout(clearSkel, 12000);
  }
  var SKIP = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkout|checkouts|account|apps|services|tools|password)(?:\/|$)/i;
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('download') || (a.target && a.target !== '_self')) return;
    if (a.closest('#zzcart, #zz-fastnav, #zz-pageskel, [data-zz-no-skel]')) return;
    if (overlay) return;                 /* a product card: the picture move already answers the tap */
    var u;
    try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.origin !== location.origin || !/^https?:$/.test(u.protocol)) return;
    if (u.pathname === location.pathname && u.search === location.search) return;
    if (SKIP.test(u.pathname)) return;
    var p = u.pathname;
    var kind = p.indexOf('/collections/') !== -1 ? 'grid'
      : p.indexOf('/products/') !== -1 ? 'product'
      : /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(p) ? 'home' : 'page';
    clearTimeout(skelT);
    navSeen = null;
    skelT = setTimeout(function () {
      /* only if the page is really leaving: a script may have cancelled this link */
      if (e.defaultPrevented) return;
      if (window.navigation && (!navSeen || navSeen.defaultPrevented)) return;
      showSkel(kind);
    }, 120);
  });
  var navSeen = null;
  try { if (window.navigation) navigation.addEventListener('navigate', function (ev) { navSeen = ev; }); } catch (x) {}

  /* ---------- 2. fetch product pages that are on screen ahead of the tap ---------- */
  (function () {
    if (!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;
    /* phones/tablets only: with a mouse, the theme already fetches on hover and that is enough */
    if (!window.matchMedia('(hover: none)').matches) return;
    var c = navigator.connection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))) return;
    var MAX = 4, n = 0, sent = {}, pend = [], flushT = null;
    function key(a) {
      try {
        var u = new URL(a.href, location.href);
        if (u.origin !== location.origin || u.pathname === location.pathname || u.pathname.indexOf('/products/') === -1) return null;
        return u.pathname + u.search;
      } catch (e) { return null; }
    }
    function flush() {
      flushT = null;
      if (!pend.length) return;
      var s = document.createElement('script');
      s.type = 'speculationrules';
      s.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: pend.splice(0) }] });
      document.head.appendChild(s);
    }
    /* Checked only when scrolling has stopped (no IntersectionObserver: it re-measured every
       product link on every animation frame, which made the cart drawer and other animations
       stutter on long collection pages). */
    function check() {
      if (n >= MAX) return;
      var vh = window.innerHeight, vw = window.innerWidth;
      var links = document.querySelectorAll('a[href*="/products/"]');
      for (var i = 0; i < links.length && n < MAX; i++) {
        var a = links[i];
        if (a.__zzpf) continue;
        var r = a.getBoundingClientRect();
        if (r.width < 30 || r.height < 30) continue;
        var visH = Math.min(r.bottom, vh) - Math.max(r.top, 0);
        var visW = Math.min(r.right, vw) - Math.max(r.left, 0);
        if (visH < r.height * 0.5 || visW < r.width * 0.5) continue;
        a.__zzpf = 1;
        if (a.closest('#zzcart, #zzmenu, #zz-fastnav')) continue;
        var k = key(a);
        if (!k || sent[k]) continue;
        sent[k] = 1; n++;
        pend.push(k);
      }
      if (pend.length && !flushT) flushT = setTimeout(flush, 60);
    }
    var idleT = null;
    function soon(ms) { clearTimeout(idleT); idleT = setTimeout(check, ms); }
    function start() {
      soon(400);
      /* capture: also catches the sideways-scrolling product rows */
      document.addEventListener('scroll', function () { soon(450); }, { capture: true, passive: true });
    }
    if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  })();
})();

/* ---- Crisp chat, loaded late (Oct 2026 #3) ----
   The Crisp app embed loaded the chat (~250 KB of script) during page load on every page. The embed is
   switched off in this theme (Theme settings > App embeds) and the same chat is started here instead:
   on the visitor's first tap / key press, or 5 s after the page finished loading, whichever is first.
   Same website ID, same cart + customer sync the app's own script did (its crisp.js, copied as-is).
   To revert: delete this block and switch the Crisp app embed back on. */
(function () {
  var ID = 'ec3a0e21-f4b1-4f01-806f-7ef8c413a5b9';
  if (window.$crisp || window.CRISP_WEBSITE_ID) return;            /* app embed is on again */
  var done = false, EV = ['pointerdown', 'keydown', 'touchstart'];
  function post(path, body) {
    return fetch(location.origin + '/apps/crisp/website/' + ID + '/session/' + window.CRISP_SESSION_ID + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    })['catch'](function () {});
  }
  function load() {
    if (done) return;
    done = true;
    EV.forEach(function (t) { window.removeEventListener(t, load, true); });
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = ID;
    var loc = (window.Shopify && window.Shopify.locale) || document.documentElement.lang;
    if (loc) window.CRISP_RUNTIME_CONFIG = { locale: loc };
    window.CRISP_READY_TRIGGER = function () {
      window.CRISP_SESSION_ID = window.$crisp.get('session:identifier');
      fetch('/cart.js').then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.items && c.items.length) post('/cart', c); })['catch'](function () {});
      var cid = window.__st && window.__st.cid;
      if (cid) post('/customer/id', { customer_id: cid });
      window.$crisp.push(['on', 'message:sent', function () {
        window.$crisp.push(['set', 'session:segments', [['shopify']]]);
        window.$crisp.push(['off', 'message:sent']);
      }]);
    };
    var s = document.createElement('script');
    s.src = 'https://client.crisp.chat/l.js';
    s.async = true;
    document.head.appendChild(s);
  }
  EV.forEach(function (t) { window.addEventListener(t, load, { capture: true, passive: true }); });
  function later() { setTimeout(load, 5000); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
})();
